"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCPF = void 0;
function formatCPF(cpf) {
    cpf = cpf.replace(/[^\d]/g, "");
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}
exports.formatCPF = formatCPF;
